import { takeLatest, call, put } from 'redux-saga/effects'
import * as fromActions from 'store/actions/blocks.action'
import { destroyOldEvaluation } from 'api/administration/blocks/Destroy'
import lessonBlocksList from 'api/administration/blocks/List'
import I18n from 'i18n'
import { SuccessToast, ErrorToast } from 'components/ui/toast/toastsTemplates'

async function getList(lessonId: number) {
  return await lessonBlocksList(lessonId)
}

async function handleDestroyEvaluationBlock(evaluationBlockId: number) {
  return await destroyOldEvaluation(evaluationBlockId)
}

function* destroyEvaluationBlockEffectSaga(action: any) {
  try {
    const {
      payload: { evaluationBlockId, lessonId },
    } = action
    yield call(handleDestroyEvaluationBlock, evaluationBlockId)
    const data = yield call(getList, lessonId)
    yield put(fromActions.Actions.getLessonBlocksListSuccess(data))
    SuccessToast(I18n.t('administration.toastMessages.deleteSuccess'))
  } catch (error) {
    ErrorToast(I18n.t('administration.toastMessages.deleteError'))
    console.log('error: ', error)
  }
}

export function* destroyEvaluationBlockWatcherSaga() {
  yield takeLatest(
    fromActions.DESTROY_EVALUATION_BLOCK,
    destroyEvaluationBlockEffectSaga
  )
}
